


















































































































import { Vue, Component } from "../vue-ext";
import { Sauna, SaunaDay, SaunaRow, Account, HousingCompany, Apartment } from "../models";
import "../components/YesNoPopup";

@Component
export default class SaunaShiftsView extends Vue {
    private saunas: Sauna[] | null = null;
    private dayNum: number = 0;
    private saunaId: number = 1;
    private weeknames: string[];
    private account: Account | null = null;
    private ownShifts: any[] = [];
    private selectedOwnShift: any | null = null;
    private selectedRowId: number | null = null;
    private housingCompany: HousingCompany | null = null;
    private confirmAddOpen: boolean = false;
    private confirmRemoveOpen: boolean = false;
    private selectedTime: string | null = null;
    private loading: boolean = true;
    private selectedApartmentId: number | null = null;
    private apartmentList: Apartment[] | null = null;

    private async created() {
        this.root.setTitle(this.$t("menu.saunaShifts") as string);
        this.root.setIconClass("icon-saunavaraukset");

        this.account = this.root.getCurrentAccount() as Account;
        this.housingCompany = this.root.getCurrentHousingCompany() as HousingCompany;

        this.weeknames = [
            this.$t("common.monday") as string, 
            this.$t("common.tuesday") as string, 
            this.$t("common.wednesday") as string, 
            this.$t("common.thursday") as string, 
            this.$t("common.friday") as string, 
            this.$t("common.saturday") as string, 
            this.$t("common.sunday") as string, 
        ];

        if (!this.account.isVerified) {
            return;
        }

        this.saunas = this.root.saunas; // await this.root.service.sauna.GetSaunas(this.housingCompany.housingCompanyId);

        this.apartmentList = await this.root.service.user.GetApartments(this.housingCompany.housingCompanyId);

        if (this.apartmentList && this.apartmentList.length > 0) {
            this.selectedApartmentId = this.apartmentList[0].apartmentId;
        }

        // for (let i = 0; i < 3; i++) {
        //     const sauna = { 
        //         id: i, 
        //         name: "Sauna " + i,
        //         description: "Tähän saunakohtaiset ohjeet esim siitä mihin aikaan pukuhuonetta voi käyttää ennen ja jälkeen saunavuoron.",
        //         saunaDays: []
        //     } as Sauna;

        //     for (let j = 0; j < 7; j++) {
        //         const saunaDay = { weekDay: j, saunaRows: [] } as SaunaDay;

        //         for (let k = 16; k < 21; k++) {
        //             const saunaRow = { 
        //                 id: k, 
        //                 time: "klo " + k,
        //                 available: (Math.floor(Math.random() * Math.floor(2)) === 1),
        //                 isOwn: (Math.floor(Math.random() * Math.floor(100)) < 3),
        //                 removed: false
        //             } as SaunaRow;

        //             saunaDay.saunaRows.push(saunaRow);
        //         }

        //         sauna.saunaDays.push(saunaDay);
        //     }

        //     this.saunas.push(sauna);
        // }
        if (this.saunas) {
            for (let i = 0; i < this.saunas.length; i++) {
                for (let j = 0; j < this.saunas[i].saunaDays.length; j++) {
                    for (let k = 0; k < this.saunas[i].saunaDays[j].shifts.length; k++) {
                        if (this.saunas[i].saunaDays[j].shifts[k].isOwn && !this.saunas[i].saunaDays[j].shifts[k].isQueuedForRemove) {
                            this.ownShifts.push({ 
                                saunaId: this.saunas[i].saunaId,
                                sauna: this.saunas[i].name,
                                day: this.saunas[i].saunaDays[j].dayOfWeek,
                                time: this.saunas[i].saunaDays[j].shifts[k].time,
                                removed: false, 
                                apartmentId: this.saunas[i].saunaDays[j].shifts[k].apartmentId 
                            });
                        }
                    }
                }
            }

            if (this.saunas.length > 0) {
                this.saunaId = this.saunas[0].saunaId;
            }
        }
        

        this.loading = false;
    }

    private changeDay(amount: number) {
        this.dayNum += amount;

        if (this.dayNum < 0) {
            this.dayNum = 0;
        }

        if (this.dayNum > 6) {
            this.dayNum = 6;
        }
    }

    private saunaRows(): SaunaRow[] | null {
        if (this.saunas) {
            const sauna = this.saunas.find(s => s.saunaId === this.saunaId) as Sauna;
            const saunaDay = sauna.saunaDays.find(sd => sd.dayOfWeek === this.dayNum) as SaunaDay;
            return saunaDay.shifts;
        }

        return [];
    }

    private async reserve(time: string) {
        this.selectedTime = time;
        this.confirmAddOpen = true;
    }

    private async confirmAddYes() {
        if (this.saunas && this.account && this.selectedTime && this.selectedApartmentId) {
            const sauna = this.saunas.find(s => s.saunaId === this.saunaId) as Sauna;
            const saunaDay = sauna.saunaDays.find(sd => sd.dayOfWeek === this.dayNum) as SaunaDay;
            const saunaRow = saunaDay.shifts.find(sr => sr.time === this.selectedTime) as SaunaRow; 

            const result = await this.root.service.sauna.Reserve(
                this.account.accountId,
                sauna.saunaId, 
                sauna.name, 
                this.dayNum, 
                this.selectedTime, 
                this.selectedApartmentId);

            if (!result.isError) {
                saunaRow.removed = true;
            }
        }

        this.confirmAddOpen = false;
    }

    private confirmAddNo() {
        this.confirmAddOpen = false;
    }

    private confirmAddText(): string {
        if (this.saunas) {
            const sauna = this.saunas.find(s => s.saunaId === this.saunaId) as Sauna;

            if (sauna) {
                return this.$t("saunaShiftsView.confirmReservation", [ sauna.name, this.weeknames[this.dayNum], this.selectedTime ]) as string;
            }
        } 

        return "";
    }


    private async removeReservation() {
        this.confirmRemoveOpen = true;
    }

    private async confirmRemoveYes() {
        if (this.ownShifts && this.selectedOwnShift && this.account) {
            const result = await this.root.service.sauna.RemoveReservation(
                this.account.accountId, 
                this.selectedOwnShift.saunaId,
                this.selectedOwnShift.sauna, 
                this.selectedOwnShift.day, 
                this.selectedOwnShift.time,
                this.selectedOwnShift.apartmentId
            );

            if (!result.isError) {
                this.selectedOwnShift.removed = true;
            }
        }

        this.confirmRemoveOpen = false;
    }

    private confirmRemoveNo() {
        this.confirmRemoveOpen = false;
    }

    private confirmRemoveText(): string {
        if (this.selectedOwnShift) {
            return this.$t("saunaShiftsView.confirmRemoveReservation", [ this.selectedOwnShift.sauna, this.weeknames[this.selectedOwnShift.day], this.selectedOwnShift.time ]) as string;
        }
        
        return "";
    }
}
